import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ArrowButton from '../../components/common/button-arrow';

class ConfirmPopup extends Component {
  modalContainer = createRef();

  render() {
    const {
      cancelDisabled, confirmDisabled, onClose, confirmLabel, cancelLabel, children, header
    } = this.props;

    return (
      <div className="modal-container" ref={this.modalContainer}>

        <Modal
          aria-labelledby="contained-modal-title"
          container={this.modalContainer.current}
          show
        >
          <Modal.Header>
            <Modal.Title>
              {header}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {children}
          </Modal.Body>
          <Modal.Footer>
            <ArrowButton
              arrow={false}
              className="float-start"
              color="grey"
              disabled={cancelDisabled}
              onClick={() => onClose(false)}
              submit={false}
            >
              {cancelLabel}
            </ArrowButton>

            <ArrowButton
              arrow={false}
              className="float-end"
              color="red"
              disabled={confirmDisabled}
              onClick={() => onClose(true)}
              submit={false}
            >
              {confirmLabel}
            </ArrowButton>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

ConfirmPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  header: PropTypes.any,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
};

ConfirmPopup.defaultProps = {
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
};

export default ConfirmPopup;
